import {Navigate} from "react-router-dom";

const AppRoute=({element})=>{
    return element
};

export default AppRoute;